/**
 * Full-page navigation to an off-origin URL, such as the OAuth redirect back to an MCP
 * client (`http://127.0.0.1:<port>/callback?code=…`). Deliberately not the SPA router and
 * not `safeReturnPath`: the target belongs to the client, not to the portal. Kept behind
 * one object so component tests can replace `assign` instead of redefining
 * `window.location`.
 */
export const externalNavigation = {
  assign(url: string): void {
    window.location.assign(url);
  }
};
